import { MenuItem, Select, Typography } from "@mui/material";
import React from "react";
import { FaPlus, FaTimes, FaSave, FaTrash, FaEdit } from "react-icons/fa";

const InvoiceDialog = ({
  openDialog,
  handleCloseDialog,
  selectedInvoice,
  setSelectedInvoice,
  governorates,
  representatives,
  selectedInvoiceItems,
  handleInputChange,
  handleDeleteItem,
  handleEditItem,
  handleSaveChanges,
  setIsModalOpen,
  handleaddItem,
}) => {
  return (
    openDialog && (
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40"
          onClick={handleCloseDialog}
        ></div>

        <div className="relative z-50 bg-white rounded-xl shadow-2xl p-8 max-w-5xl w-full mx-4 max-h-[90vh] overflow-y-auto">
          <div className="rtl">
            {/* Header */}
            <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-800">
                تعديل الفاتورة
              </h2>
              <button
                onClick={handleCloseDialog}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <FaTimes className="text-gray-500" />
              </button>
            </div>

            {/* Main Form Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {/* Customer Information Section */}
              <div className="space-y-4">
                <h3 className="text-lg font-semibold text-gray-700 mb-4">
                  معلومات العميل
                </h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      العميل
                    </label>
                    <input
                      type="text"
                      name="customer"
                      value={selectedInvoice.customer}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        الهاتف
                      </label>
                      <input
                        type="text"
                        name="phone"
                        value={selectedInvoice.phone}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        العنوان
                      </label>
                      <input
                        type="text"
                        name="address"
                        value={selectedInvoice.address}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Status and Location Section */}
              <div className="space-y-4">
                <h3 className="text-lg font-semibold text-gray-700 mb-4">
                  حالة الفاتورة والموقع
                </h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      حالة الفاتورة
                    </label>
                    <Select
                      value={selectedInvoice.status}
                      onChange={handleInputChange}
                      name="status"
                      displayEmpty
                      fullWidth
                      variant="outlined"
                      className="rounded-lg"
                    >
                      <MenuItem value="" disabled>
                        اختر الحالة الجديدة
                      </MenuItem>
                      <MenuItem value={"جديد"}>جديد</MenuItem>
                      <MenuItem value={"تحت التجهيز"}>تحت التجهيز</MenuItem>
                      <MenuItem value={"تم التسليم"}>تم التسليم</MenuItem>
                      <MenuItem value={"مرتجع"}>مرتجع</MenuItem>
                      <MenuItem value={"ملغي"}>ملغي</MenuItem>
                    </Select>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        المحافظة
                      </label>
                      <select
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        value={selectedInvoice.governorateId}
                        onChange={(event) => {
                          setSelectedInvoice((prevInvoice) => ({
                            ...prevInvoice,
                            governorateId: event.target.value,
                          }));
                        }}
                        name="governorateId"
                      >
                        <option value="">اختر المحافظة</option>
                        {governorates.map((gov) => (
                          <option key={gov.id} value={gov.id}>
                            {gov.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        المندوب
                      </label>
                      <select
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        value={selectedInvoice.representativeId}
                        onChange={(event) => {
                          if (event.target.value === "") {
                            setSelectedInvoice((prevInvoice) => ({
                              ...prevInvoice,
                              representativeId: null,
                            }));
                          } else {
                            setSelectedInvoice((prevInvoice) => ({
                              ...prevInvoice,
                              representativeId: event.target.value,
                            }));
                          }
                        }}
                        name="representativeId"
                      >
                        <option value={""}>اختر المندوب</option>
                        {representatives?.data.map((rep) => (
                          <option key={rep.id} value={rep.id}>
                            {rep.fullName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Information Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  سبب الحالة
                </label>
                <input
                  type="text"
                  name="statusCause"
                  value={selectedInvoice.statusCause}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  الشحن
                </label>
                <input
                  type="text"
                  name="shipping"
                  value={selectedInvoice.shipping}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  تاريخ الفاتوره
                </label>
                <input
                  type="date"
                  name="invoiceDate"
                  value={selectedInvoice.invoiceDate.split("T")[0]}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  الملاحظة
                </label>
                <input
                  type="text"
                  name="note"
                  value={selectedInvoice.note}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  الرقم الثاني
                </label>
                <input
                  type="text"
                  name="socendPhone"
                  value={selectedInvoice.socendPhone}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                />
              </div>
            </div>

            {/* Items Table Section */}
            <div className="mb-8">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-700">
                  المنتجات
                </h3>
                <button
                  onClick={() => handleaddItem()}
                  className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  <FaPlus className="text-sm" />
                  <span>إضافة منتج</span>
                </button>
              </div>

              <div className="bg-white rounded-lg shadow overflow-hidden">
                {selectedInvoiceItems.length ? (
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                            الفئة
                          </th>
                          <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                            الكمية
                          </th>
                          <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                            السعر
                          </th>
                          <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                            المجموع
                          </th>
                          <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                            الإجراءات
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {selectedInvoiceItems.map((item, idx) => (
                          <tr key={idx} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {item.category?.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                              {item.quantity}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                              {item.price}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                              {item.total}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-center">
                              <div className="flex justify-center gap-3">
                                <button
                                  onClick={() => handleEditItem(item)}
                                  className="text-blue-600 hover:text-blue-800 transition-colors"
                                >
                                  <FaEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteItem(item)}
                                  className="text-red-600 hover:text-red-800 transition-colors"
                                >
                                  <FaTrash />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-8 text-gray-500">
                    <p className="text-lg">لا توجد منتجات مضافة</p>
                  </div>
                )}
              </div>
            </div>

            {/* Footer Actions */}
            <div className="flex justify-end gap-4 pt-4 border-t border-gray-200">
              <button
                className="flex items-center gap-2 px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                onClick={handleCloseDialog}
              >
                <FaTimes />
                <span>إلغاء</span>
              </button>
              <button
                className="flex items-center gap-2 px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                onClick={handleSaveChanges}
              >
                <FaSave />
                <span>حفظ التغييرات</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default InvoiceDialog;
